import "./Terms.scss";
import grid1 from "../../assets/grid1.png";
import grid2 from "../../assets/grid2.png";
import grid3 from "../../assets/grid3.png";
import grid4 from "../../assets/grid4.png";
import grid5 from "../../assets/grid5.png";
import grid6 from "../../assets/grid6.png";
import grid7 from "../../assets/grid7.png";
import grid8 from "../../assets/grid8.png";
import grid9 from "../../assets/grid9.png";

export default function Terms() {
  return (
    <div className="terms spacing">
      <div className="left">
        <h1>
          We offer custom solutions with crypto-ready<span> terms for:</span>
        </h1>
        <button onClick={()=>{const inHouseSection = document.getElementById("security-section"); if(inHouseSection){ inHouseSection.scrollIntoView({behavior:'smooth'}) }}} className="desktopbtn btnn">Browse All</button>
      </div>
      <div className="right">
        <div className="gridcontainer">
          <div className="box">
            <img src={grid1} alt="error" />
            <span>Casinos</span>
          </div>
           <div className="box">
            <img src={grid4} alt="error" />
            <span>Trading Platform</span>
          </div>
          <div className="box">
            <img src={grid7} alt="error" />
            <span>Adult Business</span>
          </div>
           <div className="box">
            <img src={grid2} alt="error" />
            <span>iGaming</span>
          </div>
          <div className="box">
            <img src={grid5} alt="error" />
            <span>Token Generation Events</span>
          </div>
          <div className="box">
            <img src={grid8} alt="error" />
            <span>E-commerce</span>
          </div>
          <div className="box">
            <img src={grid3} alt="error" />
            <span>SaaS & Web Services</span>
          </div>
          <div className="box">
            <img src={grid6} alt="error" />
            <span>Marketplace</span>
          </div>
          <div className="box">
            <img src={grid9} alt="error" />
            <span>Charity</span>
          </div>
        </div>
        <button className="mobilebtn btnn">Explore all</button>
      </div>
    </div>
  );
}
